import "./initializers/set_storage";

import { getConfig } from "PFConfig";

window.PF = {
  Initializers: {},
  config: getConfig()
};
